// extracted by mini-css-extract-plugin
export var container = "_ez-1";
export var cornerButtonContainer = "_ez-6";
export var disabled = "_ez-2";
export var dragActive = "_ez-3";
export var fileContainer = "_ez-5";
export var hiddenInput = "_ez-4";
export var widthContainer = "_ez-0";